import React, { Fragment, useEffect, useState } from "react";

import Breadcrumb from "../Breadcrumb/Breadcrumb";
import {
  SubmitButton,
  Input,
  Textarea,
  SelectInput,
  CustomSelectInput,
  SubTab,
  SubInput,
} from "../Form/Form";
import { useForm } from "react-hook-form";
import { requestHandler } from "../../services/requestHandler";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { updateLoading } from "../../store/auth/action";
import { useHistory } from "react-router-dom";
import { capitalizeFirstLetter } from "../../util/fn";
import Pagination from "../Pagination/Pagination";

const OBJ_TABLE = {
  "First Name": "firstName",
  email: "email",
  role: "role",
};

export default function CustomNotification() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { languages, records_per_page } = useSelector((state) => state.setting);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [filterValue, setfilterValue] = useState("");
  const [selectedUser, setSelectedUser] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(1);
  const [perPage, setPerPage] = useState(records_per_page||10);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    control,
    reset,
  } = useForm();

  const fetchUsers = async (search) => {
 
    const response = await requestHandler(
      "GET",
      `user/get-all-users?page=${page}&per_page=${perPage}&search=${
        search ?? ""
      }`,
      {},
      dispatch
    );
    if (response?.status) {
      setUsers(response?.users);
      setTotalDocuments(response?.pagination?.totalDocuments ?? 0);
    }
  };
  console.log("selectedUser :", selectedUser);
  useEffect(() => {
    setPerPage(records_per_page ?? 0);
    fetchUsers();
  }, [page]);

  // Pagination
  const fetchMoreData = ({ selected }) => {
    setPage(selected + 1);
  };
  const perPageChangeHandler = (event) => {
    setPage(1);
    setPerPage(event.target.value);
  };

  const onSubmit = async (data) => {
    dispatch(updateLoading({ loading: true }));
    const { sendType } = data;
    if (sendType === "custom" && selectedUser?.length === 0) {
      toast.error(
        "Before proceeding, kindly select the user you wish to send the notification to."
      );
      return;
    }
    let translate = {};
    languages?.forEach((lang) => {
      translate[lang.code] = {
        title: data[`title-${lang.code}`],
        body: data[`body-${lang.code}`],
      };
    });
    // Generate data set
    const reqBody = {
      sendType,
      translate,
      usersId: selectedUser,
    };

    const response = await requestHandler(
      "POST",
      "custom-notification/create",
      reqBody,
      dispatch
    );
    if (response.status) {
      toast.success(response.message);
      reset({});
      history.push("/custom-notification");
    }
    dispatch(updateLoading({ loading: false }));
  };
  const checkboxHandler = (data, check) => {
    if (data === "all") {
      if (check) {
        let usersData = [...users];
        usersData =
          usersData?.length > 0 ? usersData?.map((res) => res?._id) : [];
        setSelectedUser(usersData);
      } else {
        setSelectedUser([]);
      }
    } else {
      if (check) {
        setSelectedUser((prevState) => [...prevState, data]);
      } else {
        let checkedUsers = [...selectedUser];
        checkedUsers =
          checkedUsers?.length > 0
            ? checkedUsers?.filter((item) => item !== data)
            : [];
        setSelectedUser(checkedUsers);
      }
    }
  };
  watch("sendType");
  // Get the first key of the error object
  var firstKey = Object.keys(errors)[0];

  // Filter data from table
  function filterContacts() {
    // const loweredFilter = filterValue ? filterValue.toLowerCase() : ""; // Handle empty filter

    // let newUser = users.filter((item) => {
    //   const firstNameMatch = item.firstName
    //     .toLowerCase()
    //     .includes(loweredFilter);
    //   const emailMatch = item.email?.toLowerCase().includes(loweredFilter);
    //   return firstNameMatch || emailMatch; // OR condition for matching either field
    // });
    // setUsers(newUser);
    fetchUsers(filterValue)
  }
  function resetFunction() {
    setValue("select_all", false);
    setfilterValue("");
    fetchUsers();
  }
  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title={`Custom Notification`}
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/custom-notification", name: "Back To Notification List" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card w-100">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* Notification Fields */}
                      <div className="col-xl-12">
                        <div className="card-header card-header-tabs-line">
                          <div className="card-toolbar">
                            <ul
                              className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                              role="tablist"
                            >
                              {languages.length > 0 &&
                                languages.map((lang, index) => (
                                  <SubTab
                                    key={lang.code}
                                    name={lang.name}
                                    index={index}
                                    image={lang?.image}
                                    tabName={`language_${index}`}
                                  />
                                ))}
                            </ul>
                          </div>
                        </div>
                        <div className="card-body px-0">
                          <div className="tab-content px-10">
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  required={true}
                                  control={control}
                                  code={lang.code}
                                  tabName={`language_${index}`}
                                  InputFields={[
                                    // Language-specific input fields for each language
                                    // For example, for English (lang.code === 'en')
                                    [
                                      {
                                        Component: Input,
                                        type: "text",
                                        label: "Title",
                                        name: "title",
                                        registerFields: { required: true },
                                        errors: { errors },
                                        register: { register },
                                        colClass: "col-xl-12",
                                      },

                                      {
                                        Component: Textarea,
                                        name: `body`,
                                        textareaHeight: "height-full",
                                        label: "Notification Body",
                                        placeholder: "Enter Notification Body.",
                                        colClass: "col-xl-12 h-100",
                                        register: { register },
                                        errors: { errors },
                                        registerFields: {
                                          required: true,
                                          setValueAs: (v) => v.trim(),
                                        },
                                      },
                                    ],
                                  ]}
                                />
                              ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <div className="row">
                          <div className="col-xl-12">
                            <CustomSelectInput
                              label="Send Type"
                              name="sendType"
                              colClass="col-xl-12"
                              registerFields={{
                                required: true,
                              }}
                              control={control}
                              errors={errors}
                              register={register}
                              children={
                                <>
                                  <option value="">Select Type</option>
                                  <option value="all_customer">
                                    All Customer
                                  </option>
                                  <option value="all_service_provider">
                                    All Service Provider
                                  </option>
                                  <option value="both">
                                    Both(Customer and Service Provider)
                                  </option>
                                  <option value="custom">Custom</option>
                                </>
                              }
                            />
                          </div>
                          {getValues("sendType") == "custom" ? (
                            <div className="col-xl-12">
                              <div
                                style={{
                                  float: "right",
                                  display: "flex",
                                  gap: "5px",
                                  marginBottom: "5px",
                                }}
                              >
                                <input
                                  type="text"
                                  value={filterValue}
                                  onChange={(e) =>
                                    setfilterValue(e.target.value)
                                  }
                                  placeholder="Search by name, email"
                                  className="form-control w-10 border"
                                />
                                <button
                                  className="btn btn-primary"
                                  onClick={filterContacts}
                                  type="button"
                                >
                                  Search
                                </button>
                                <button
                                  className="btn btn-primary"
                                  onClick={resetFunction}
                                  type="button"
                                >
                                  Reset
                                </button>
                              </div>
                              <div
                                className="table-responsive"
                                // style={{ height: "50vh" }}
                              >
                                <table
                                  className="table dataTable table-head-custom table-head-bg table-borderless table-vertical-center"
                                  id="taskTable"
                                >
                                  <thead>
                                    <tr className="text-uppercase">
                                      <th>
                                        <input
                                          type="checkbox"
                                          title="Select All"
                                          name="select_all"
                                          {...register("select_all", {
                                            onChange: (e) => {
                                              checkboxHandler(
                                                "all",
                                                e.target.checked
                                              );
                                            },
                                          })}
                                        />
                                      </th>
                                      {Object.keys(OBJ_TABLE).map(
                                        (heading, index) => (
                                          <th key={index}>
                                            <a className="no_sort">{heading}</a>
                                          </th>
                                        )
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {users?.length > 0 &&
                                      users?.map((data) => (
                                        <tr key={data._id}>
                                          <td>
                                            <div className="d-flex align-items-center">
                                              <div className="text-dark-75 mb-1  font-size-lg">
                                                <input
                                                  type="checkbox"
                                                  name={data?._id}
                                                  checked={selectedUser?.includes(
                                                    data._id
                                                  )}
                                                  onChange={(e) =>
                                                    checkboxHandler(
                                                      data._id,
                                                      e.target.checked
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </td>

                                          {Object.values(OBJ_TABLE)?.map(
                                            (tData, index) => {
                                              let value =
                                                tData == "role"
                                                  ? capitalizeFirstLetter(
                                                      data[tData] || ""
                                                    )
                                                  : data[tData];

                                              return (
                                                <td
                                                  key={index}
                                                  className="py-5"
                                                >
                                                  <div className="d-flex align-items-center">
                                                    <div className="text-dark-75 mb-1  font-size-lg">
                                                      {value || "-"}
                                                    </div>
                                                  </div>
                                                </td>
                                              );
                                            }
                                          )}
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>

                              {perPage !== 0 && (
                                <Pagination
                                  page={page}
                                  totalDocuments={totalDocuments}
                                  getNewData={fetchMoreData}
                                  perPage={perPage}
                                  defaultPerPage={records_per_page}
                                  perPageChangeHandler={perPageChangeHandler}
                                  currentDocLength={users.length}
                                />
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xl-12">
                        {Object.keys(errors).length > 0 ? (
                          <p className="invalid-feedback">
                            {errors[firstKey].type === "required"
                              ? "Please ensure all required fields are filled out before proceeding."
                              : null}
                          </p>
                        ) : null}
                      </div>
                    </div>
                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
